<div *ngIf="this.loading==true" style="height: 100vh; width:100%; align-items: center; justify-content: center; display: flex;">
     <mat-spinner></mat-spinner>
     <h1>Si prega di attendere, elaborazione in corso....</h1>
 </div>
<div *ngIf="this.loading==false"
     leaflet
     [leafletOptions]="options"
     (leafletMapReady)="onMapReady($event)"
     (leafletMapZoomEnd)="onMapZoomEnd($event)"
     id='waypoints-lap-map'
>
     <div 
          *ngIf="this.opened" 
          class="filter-table"
          (wheel)="stopScroll($event)"
          appStopEventPropagation
     >
          <app-taggable-resource-route-map-grid  
               [data]="data.steps" 
               [length]="data.steps.length"
               (flyToPoint)="flyToPoint($event)"
               (reorder)="reorder($event)"
               (onDragStart)="onDragStart()"
               (onDragEnd)="onDragEnd()"
               >
          </app-taggable-resource-route-map-grid>
     </div>
     <div class="filter-button" >
          <button class="button" mat-button (click)="saveRoute()" type="button" style="background-color: green;" *ngIf="this.saveBtn">
               <span class="fa fa-save fa-2x" >
               </span>
          </button>
          <button class="button" mat-button (click)=toggleDisplayDiv() type="button" [class.button--enabled]="!this.opened">
               <span class="fa fa-bars fa-2x" >
               </span>
          </button>
     </div>
</div>